(() => {
  // /customsegments/ page
  angular
    .module('app.campaign')
    .controller('CustomSegmentsListController', List);

  List.$inject = [];

  function List() {
    const vm = this;
  }
})();
